package utils

import io.ktor.util.encodeBase64

fun ByteArray.toDataUrl(mimeType: String): String {
    return "data:$mimeType>;base64,${this.encodeBase64()}"
}
